export enum FlowType {
  SELL_HOUSE = 'sell_house',
  SELL_FLAT = 'sell_flat',
  SELL_PROPERTY = 'sell_property',
}
